import Image from "next/image";

const TinyLoader = () => {
  return (
    <div className="my-64 flex w-full justify-center ">
      <Image alt="loader" src="/assets/loader.gif" height={112} width={112} />.
    </div>
  );
};

export { TinyLoader };
